export enum WhiteLabelApps {
  SHIFTKEY = 'SHIFTKEY_WALLET',
}
